import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useContext } from 'react';
import { Button } from 'semantic-ui-react';
import _sortBy from 'lodash/sortBy';
import { MAX_LINKS_TO_SHOW, SEE_LESS, SEE_MORE, SORTING_FIELDS } from './AccordionLinks.constants';
import { SiteNavigationLinkPropType } from '../../../../../../../../services/proptypes';
import Accordion from '../../../../../../../foundation/components/Accordion';
import Icon from '../../../../../../../foundation/components/Icon';
import { NavigationContext } from '../../../../Navigation.context';
import BaseLink from '../../../Link';
import { generateKey } from '../../../Links/Links.utils';
import './AccordionLinks.less';
var defaultProps = {
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  onLinkClick: function onLinkClick() {
    return null;
  },
  initialActive: false
};
export default function AccordionLinks(_ref) {
  var link = _ref.link,
    maxLinksToShow = _ref.maxLinksToShow,
    onLinkClick = _ref.onLinkClick,
    initialActive = _ref.initialActive;
  var _useContext = useContext(NavigationContext),
    setToggled = _useContext.setToggled;
  var _useState = useState(initialActive),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showAllLinks = _useState4[0],
    setShowAllLinks = _useState4[1];
  function toggleShowAllLinks() {
    setShowAllLinks(function (previousShowAllLinks) {
      return !previousShowAllLinks;
    });
  }
  function toggleActive() {
    setActive(function (previousActive) {
      return !previousActive;
    });
  }
  var title = link.title,
    childPages = link.childPages;
  var totalChildPages = childPages.length;
  var linksToShow = showAllLinks ? totalChildPages : maxLinksToShow;
  var finalChildPages = _sortBy(childPages, SORTING_FIELDS).slice(0, linksToShow);
  return /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(Accordion.Title, {
    active: active,
    onClick: toggleActive
  }, /*#__PURE__*/React.createElement("span", null, title), /*#__PURE__*/React.createElement(Icon, {
    iconName: active ? 'angle-down' : 'angle-right'
  })), /*#__PURE__*/React.createElement(Accordion.Content, {
    active: active
  }, /*#__PURE__*/React.createElement(React.Fragment, null, finalChildPages.map(function (_ref2) {
    var childTitle = _ref2.title,
      childUrl = _ref2.url,
      childSlug = _ref2.slug;
    var childKey = generateKey(childTitle, childUrl, childSlug);
    return /*#__PURE__*/React.createElement(BaseLink, {
      key: childKey,
      title: childTitle,
      url: childUrl,
      slug: childSlug,
      onClick: function onClick() {
        // close navigation bar when a link is clicked
        setToggled(false);
        onLinkClick();
      }
    });
  }), totalChildPages > MAX_LINKS_TO_SHOW && /*#__PURE__*/React.createElement(Button, {
    className: "show-more",
    content: showAllLinks ? SEE_LESS : SEE_MORE,
    onClick: toggleShowAllLinks
  }))));
}
AccordionLinks.defaultProps = defaultProps;